import {
    ApolloClient,
    InMemoryCache,
    NormalizedCacheObject,
} from '@apollo/client';
import { ApolloClientOptions } from '@apollo/client/core/ApolloClient';

export const createApolloClient = <
    TCacheShape extends NormalizedCacheObject = NormalizedCacheObject,
>(
    options: Partial<ApolloClientOptions<TCacheShape>> = {},
) => {
    const { cache = new InMemoryCache() } = options;
    return new ApolloClient({
        cache,
        connectToDevTools: import.meta.env.MODE === 'development',
        queryDeduplication: true,
        ...options,
    });
};
